// src/components/ForgotPasswordPage.js
import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { Link } from "react-router-dom";
import bgImage from "../assets/maritime-bg.jpg"; // ✅ background image

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("✅ Reset link sent! Check your inbox.");
    } catch (err) {
      console.error("Password reset error:", err.message);
      setError("❌ Failed to send reset link. Try again.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        fontFamily: "Montserrat, sans-serif",
        position: "relative",
      }}
    >
      {/* Reset Card */}
      <div
        style={{
          background: "rgba(34, 40, 54, 0.85)",
          backdropFilter: "blur(6px)",
          padding: "35px",
          borderRadius: "16px",
          boxShadow: "0 8px 25px rgba(0, 147, 255, 0.3)",
          width: "350px",
          textAlign: "center",
          color: "#DCE4F2",
        }}
      >
        <h2 style={{ marginBottom: "20px" }}>Reset Password</h2>

        {message && (
          <div
            style={{
              backgroundColor: "#00D160",
              color: "white",
              padding: "10px",
              borderRadius: "6px",
              marginBottom: "15px",
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            {message}
          </div>
        )}

        {error && (
          <div
            style={{
              backgroundColor: "#FF4C4C",
              color: "white",
              padding: "10px",
              borderRadius: "6px",
              marginBottom: "15px",
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleReset}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              width: "100%",
              padding: "12px",
              marginBottom: "15px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          />
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px",
              background: "#00D160",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
              transition: "background 0.3s ease",
            }}
          >
            Send Reset Link
          </button>
        </form>

        <div style={{ marginTop: "20px" }}>
          <Link
            to="/login"
            style={{
              color: "#0093FF",
              textDecoration: "none",
              fontSize: "14px",
            }}
          >
            ← Back to Login
          </Link>
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          background: "rgba(0,0,0,0.6)",
          color: "#DCE4F2",
          textAlign: "center",
          padding: "10px 0",
          fontSize: "14px",
        }}
      >
        Copyright © 2026. Equity Insight. All Rights Reserved.
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
